import styled from 'styled-components'
import { ContainerSombra } from '../../components/ContainerSombra'

export const iniciarCicloStyles = {
  Container: styled(ContainerSombra)`
    margin-top: 19px;
  `
}
